import { timestampFromDate } from '@bufbuild/protobuf/wkt'
import { BidSegment } from '@ebalance/proto/bfftypes/v1/bid_segment_pb'

/**
 * 初回保存 (= 対象 row 未作成で baseline updatedAt が無い) 時に楽観ロック
 * baseline (expectedUpdatedAt) へ渡す番兵。proto 側で expected_updated_at は
 * required のため undefined では送れず、epoch (= Unix 0) を送る。backend は
 * epoch を「baseline 無し = 初回 INSERT」として option.None にたたむ
 * (handler/bidlimit/converter.go の timestampToOptionTime)。
 */
export const FIRST_SAVE_EXPECTED_UPDATED_AT = timestampFromDate(new Date(0))

/**
 * JEPX 取引対象エリア (沖縄 area_code=0 を除外した 9 エリア)
 * 設計書 §5 grill log Q2 確定: "marketAreas を i18n / 配列 const で持つ"
 */
export const MARKET_AREAS: ReadonlyArray<{ code: number; nameKey: string }> = [
  { code: 1, nameKey: 'page:adminBidLimits.area.hokkaido' },
  { code: 2, nameKey: 'page:adminBidLimits.area.tohoku' },
  { code: 3, nameKey: 'page:adminBidLimits.area.tokyo' },
  { code: 4, nameKey: 'page:adminBidLimits.area.chubu' },
  { code: 5, nameKey: 'page:adminBidLimits.area.hokuriku' },
  { code: 6, nameKey: 'page:adminBidLimits.area.kansai' },
  { code: 7, nameKey: 'page:adminBidLimits.area.chugoku' },
  { code: 8, nameKey: 'page:adminBidLimits.area.shikoku' },
  { code: 9, nameKey: 'page:adminBidLimits.area.kyushu' },
]

/** 3 matrix segment (UNSPECIFIED / TAG_ONLY は含まない) */
export const MATRIX_SEGMENTS = [
  BidSegment.SPOT_NORMAL,
  BidSegment.SPOT_BLOCK,
  BidSegment.INTRADAY,
] as const

/** market order policy が存在する segment */
export const MARKET_ORDER_SEGMENTS = [
  BidSegment.SPOT_NORMAL,
  BidSegment.INTRADAY,
] as const
